/**
 * Sidebar delete-confirmation dialog, shared by the "Delete chat?" and
 * "Delete module?" confirm overlays. The orchestrator gates rendering on the
 * delete-target state, so callers must mount this only when a target exists.
 */

interface DeleteConfirmDialogProps {
  title: string;
  targetName: string;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmDialog({
  title,
  targetName,
  isPending,
  onClose,
  onConfirm,
}: DeleteConfirmDialogProps) {
  return (
    <div className="conversation-delete-confirm-overlay" onClick={onClose}>
      <div className="conversation-delete-confirm-modal" onClick={(event) => event.stopPropagation()}>
        <h3 className="conversation-delete-confirm-title">{title}</h3>
        <p className="conversation-delete-confirm-message">
          Permanently delete <strong>{targetName}</strong>? This action cannot be undone.
        </p>
        <div className="conversation-delete-confirm-actions">
          <button
            className="conversation-delete-confirm-btn conversation-delete-confirm-btn-cancel"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </button>
          <button
            className="conversation-delete-confirm-btn conversation-delete-confirm-btn-danger"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
